import { render, staticRenderFns } from "./SkuItem.vue?vue&type=template&id=02bf5946&scoped=true"
import script from "./sku_item.js?vue&type=script&lang=js&external"
export * from "./sku_item.js?vue&type=script&lang=js&external"
import style0 from "./sku_item.scss?vue&type=style&index=0&id=02bf5946&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bf5946",
  null
  
)

export default component.exports